import cx from 'classnames';
import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import Coin from 'components/Coin';
import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import NameAndSignatureQuery from 'components/NameAndSignatureQuery';
import PotentialChatMember from 'entities/PotentialChatMember';
import Text from 'components/Text';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities';
import UserAvatar from 'users/components/UserAvatar';

import './styles/MessageStarterItem.scss';

class MessageStarterItem extends React.Component<
  {
    member: PotentialChatMember;
    selectable: boolean;
    selected: boolean;
    query: string;
    className?: string | null;
    statusIndicator?: any;
  },
  any
> {
  static defaultProps = {
    selectable: false,
    selected: false,
  };

  // @ts-expect-error ts-migrate(7023) FIXME: 'shouldComponentUpdate' implicitly has return type... Remove this comment to see the full error message
  shouldComponentUpdate(nextProps: any) {
    // HACK assumes `member` doesn't mutate during the life of this component
    return shallowCompare(this, nextProps, this.state);
  }

  renderDroplet() {
    if (this.props.selectable) {
      if (this.props.selected) {
        return (
          <Coin className="MessageStarterItem-droplet" color="mascot" size="xxxlarge">
            <Glyph name="check" color="whiteout" size="large" solo />
          </Coin>
        );
      } else {
        return <Coin className="MessageStarterItem-droplet" border="percussion" size="xxxlarge" />;
      }
    }

    const { member } = this.props;
    const user = member.getUser();

    return <UserAvatar size="medium" user={user.toJSON()} />;
  }

  render() {
    const { member, query } = this.props;
    const parser = TextEntities.createTextMatchingParser(query);

    return (
      <a className={cx('MessageStarterItem', this.props.className)}>
        <MediaObject center figure="right" className="MessageStarterItem-inner">
          <MediaObject center gutter="small">
            {this.renderDroplet()}
            <div>
              <NameAndSignatureQuery
                displayName={member.getName()}
                fullName={member.getUser().getFullName()}
                query={query}
              />
              <Text color="percussion" size="xsmall" truncate>
                <TextWithEntities
                  text={member.getConnectionDescription()}
                  entities={parser(member.getConnectionDescription())}
                />
              </Text>
            </div>
          </MediaObject>
          {this.props.statusIndicator || <div />}
        </MediaObject>
      </a>
    );
  }
}

export default MessageStarterItem;
